import { Box, Stack } from '@mui/material';
import { colors, Typography, Button } from '@sweep-io/sweep-design';
import ArrowRightSmall from './arrowRightSmall.svg?react';
import { ActionPaywallSource } from '../../dashboard/paywall/paywallTypes';
import usePaywall from '../../dashboard/paywall/usePaywall';
import { useRunOnceWhenTruthy } from '../useRunOnceWhenTruthy';
import usePageblockEvents from '../../../hooks/usePageblockEvents';

const AiChatPaywallBlockMessage = () => {
  const { isPaywallActive, sendEncounterPaywallEvent } = usePaywall();
  const { bookDemoAndSendEvent } = usePageblockEvents();

  useRunOnceWhenTruthy(() => {
    sendEncounterPaywallEvent({
      source: ActionPaywallSource.AI_CHAT,
    });
  }, isPaywallActive);

  if (!isPaywallActive) {
    return null;
  }

  return (
    <Stack gap="10px">
      <Typography variant="body" color={colors.grey[800]}>
        To get answers from Sweep’s AI Assistant, activate your free trial now.
      </Typography>
      <Box>
        <Button onClick={() => bookDemoAndSendEvent(ActionPaywallSource.AI_CHAT)} size="small">
          <Box display="flex" alignItems="center" gap="6px">
            <Typography variant="caption-bold">Talk to us</Typography>
            <ArrowRightSmall />
          </Box>
        </Button>
      </Box>
    </Stack>
  );
};

export default AiChatPaywallBlockMessage;
